import { Injector } from "@angular/core";
import { SystemSettingsService } from "@app/core/services/system-settings.service";
import { setAppInjector } from "./app-injector";

/**
 * AppInitializationFactory()
 *
 * This function is invoked during application initialization / load.
 * The APP_INITIALIZER is defined in core.module.ts
 *
 * The purpose of this factory implemenation is to establish system settings required
 * by the application before displaying any screen.
 *
 * @param injector
 */
export function AppInitializationFactory(injector: Injector, sysSettingsService: SystemSettingsService) {
  // Set global app injector
  setAppInjector(injector);

  // Load settings
  return () => sysSettingsService.loadSettings();
}
